import { Component, OnInit , Renderer2, ElementRef} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { Location } from '@angular/common';

@Component({
  selector: 'echexpayment-status',
  templateUrl: './statusform.component.html',
  styleUrls: ['./status.component.css']
})
export class EditstatusComponent implements OnInit {

  editStatus: boolean = true;
  addStatus: boolean = false;
  busy: Subscription;
  public color: string = "#127bdc";
  public token: string;
  public validation_status_name :boolean = false;
  public validation_status_color :boolean = false;
  public validation_status_code :boolean = false;
  public validation_status_id :boolean = false;

  public status: any = {};
  NamecharacterLimitReached: { [key: string]: boolean } = {};
  
  constructor(private router: Router, private location : Location, private toastr: ToastrService,private elementRef : ElementRef, private renderer :  Renderer2, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService, private route: ActivatedRoute) { 
	this.router = router;
	var currentUser = this.localStorageService.getData("currentUserToken");
	this.token =  currentUser.data.user_token;
  }

  ngOnInit() {
	this.getEditStatus(); 
  }
  // event handler for validation	
  eventHandler(){
    this.validation_status_name = false;
    this.validation_status_color = false;
    this.validation_status_code = false;
    this.validation_status_id = false;
  }
  // Get status by id
  getEditStatus() {
    let params: any = this.route.snapshot.params;
    let data = {
      token:params.id,
      user_token:this.token,
      id:params.id,
    }
	let responseData = <any>{};
    this.busy = this.echexpaymentService.getEditStatusData(data).subscribe(
       response => {
	   responseData = response;
          this.status = responseData.data;
          this.color =  this.status.status_color;
       },
       error => {
			responseData = error;
			this.toastr.error(responseData.error.message, 'Failed!');
       }
    );
  }
   // Get color code	
   getColorCode(event){
      this.status.status_color = event;
   }
	
   //Back navigate
   goBack(){
    this.location.back();
   }

   onColorInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value.trim();

    // If the input value is empty, set the color to null
    if (inputValue === '') {
      this.status.status_color = null;
    }
  }
  
   // Update status	
   updateStatus(data) {
    this.focusFirstInvalidControlPlus();   //focus field
		if(data.valid && this.status.status_color){
			    let model: any = data.value;
          model.user_token = this.token;
          model.status_color = this.status.status_color ? this.status.status_color : this.color;

          let params: any = this.route.snapshot.params;
          model.id = params.id;
          model.token = params.id;
          let responseData = <any>{};
          this.busy = this.echexpaymentService.updateStatus(model).subscribe(
            response => {
          responseData = response;
                this.toastr.success(responseData.message, 'Success!');
                this.router.navigate(['/status']);
            },
            error => {
            responseData = error;
            this.toastr.error(responseData.error.message, 'Failed!');
            }
          );
      }
  }

  // Focus Error Field
  focusFirstInvalidControlPlus(): void {
    const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
    if (firstElementWithErrors) {
      firstElementWithErrors.focus();
    }
  }

  // Enter Key Focus Next Field
  moveNext(nextInput: HTMLInputElement, checkbox: number = 0) {
    if(checkbox === 2){
      const saveButton = document.getElementById('submitButton') as HTMLElement;
      if (saveButton) {
        saveButton.focus();
        saveButton.click();
      }
    } else{
      nextInput && nextInput.focus();
    }
  }

  ngAfterViewInit(){
    this.renderer.selectRootElement('#InitialFocus').focus();
  }

  NameCharacterLimit(event: any, fieldName: string) {
    const maxTextLength = 25; // Maximum text length of 20 characters
    const inputChar = event.key;
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
    const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
  
    if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
      return;
    }
  
    const inputValue = event.target.value;
  
    if (inputValue.length >= maxTextLength) {
      if (allowedKeys.indexOf(inputChar) === -1) {
        this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
        setTimeout(() => {
          this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
        }, 3000);
        event.preventDefault(); // Prevent entering the exceeded character
      }
    }
  }
  
  isNameLimitReached(fieldName: string): boolean {
    return this.NamecharacterLimitReached[fieldName];
  }


    // disallow 0
    validateNumberInput(event: any) {
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
      const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
      
      if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
        // Allow the default behavior for certain keys
        return;
      }
      
      if (!/^\d+$/.test(event.key)) {
        // Prevent input if it's not a digit
        event.preventDefault();
      }
    }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/status/editstatus.component.ts